__turbopack_context__.v({
  "footer": "footer-module__PvSZgW__footer",
  "footer_content": "footer-module__PvSZgW__footer_content",
  "footer_copyright": "footer-module__PvSZgW__footer_copyright",
  "footer_legal": "footer-module__PvSZgW__footer_legal",
  "footer_legal_item": "footer-module__PvSZgW__footer_legal_item",
  "footer_legal_links": "footer-module__PvSZgW__footer_legal_links",
  "footer_social": "footer-module__PvSZgW__footer_social",
  "footer_social_item": "footer-module__PvSZgW__footer_social_item",
  "made_by": "footer-module__PvSZgW__made_by",
});
